module.exports = __webpack_public_path__ + "media/images/emblems/Flaach-blazon-b483a61154b08f930d950649fc4104af.svg";